<template>
  <v-data-table :headers="headers" :items="items" item-key="name" hide-actions class="elevation-1 data-table mb-3" no-data-text="Нет данных для отображения">
    <template slot="headerCell" slot-scope="props">
      <v-tooltip bottom>
        <span slot="activator">{{ props.header.text }}</span>
        <span>{{ props.header.text }}</span>
      </v-tooltip>
    </template>
    <template slot="items" slot-scope="props">
      <slot :item="props.item" :index="props.index"></slot>
    </template>
  </v-data-table>
</template>

<script>

export default {
  props: {
    headers: Array,
    items: Array
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/fragments/DataTable.vue